import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { exchangeGoogleSession } from "@/lib/journeyApi";

const safeReturnTo = (value) => (value?.startsWith("/") ? value : "/account");

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = new URLSearchParams(location.hash.replace(/^#/, ""));
    const query = new URLSearchParams(location.search);
    const sessionId = hash.get("session_id");
    const returnTo = safeReturnTo(query.get("returnTo"));
    if (!sessionId) {
      navigate(`/signin?returnTo=${encodeURIComponent(returnTo)}`, { replace: true });
      return;
    }

    const complete = async () => {
      try {
        const user = await exchangeGoogleSession(sessionId, query.get("consent") === "1");
        setUser(user);
        window.history.replaceState(null, "", `${location.pathname}${location.search}`);
        const destination = returnTo === "/supplement-check" || user.profile_completed
          ? returnTo
          : `/profile?returnTo=${encodeURIComponent(returnTo)}`;
        navigate(destination, {
          replace: true,
        });
      } catch {
        navigate(`/signin?returnTo=${encodeURIComponent(returnTo)}`, { replace: true });
      }
    };
    complete();
  }, [location.hash, location.pathname, location.search, navigate, setUser]);

  return null;
};